/** Colour helpers. textOn, contrastRatio and initials come from @castfeeds/domain; the rest are web-only. */
export { contrastRatio, initials, textOn } from '@castfeeds/domain';

export function rgb(hex: string): [number, number, number] {
  const h = hex.replace('#', '').trim();
  const full = h.length === 3 ? h.split('').map((c) => c + c).join('') : h.padEnd(6, '0').slice(0, 6);
  return [0, 2, 4].map((i) => parseInt(full.slice(i, i + 2), 16) || 0) as [number, number, number];
}

/** Alpha-composite `rgba(r,g,b,a)` or `#hex` over an opaque hex background → hex. */
export function composite(fg: string, bg: string): string {
  const m = fg.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*([\d.]+))?\s*\)/);
  if (!m) return fg;
  const a = m[4] === undefined ? 1 : Number(m[4]);
  const [br, bgc, bb] = rgb(bg);
  const mix = (f: number, b: number) => Math.round(f * a + b * (1 - a));
  const out = [mix(+m[1], br), mix(+m[2], bgc), mix(+m[3], bb)];
  return '#' + out.map((n) => n.toString(16).padStart(2, '0')).join('');
}

export function isHex(value: string): boolean {
  return /^#[0-9A-Fa-f]{6}$/.test(value);
}

/** Stable avatar colour per person (prototype palette; all readable with Ink text). */
const AVATAR = ['#F2A93B', '#8FA6FF', '#3CC77A', '#FF8A73', '#C9B8FF', '#7FD1C7', '#F7A8C8', '#FFD23F', '#E9B4C0', '#7EE3C4'];
export function avatarColour(seed: string): string {
  let h = 0;
  for (const ch of seed) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return AVATAR[h % AVATAR.length];
}

